"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclosureMinimalDetailsSchema = exports.DisclosureDTOSchema = exports.RelatedDisclosureIMSchema = void 0;
const contributor_1 = require("../core-model-schemas/contributor");
const dean_1 = require("../core-model-schemas/dean");
const disclosure_1 = require("../core-model-schemas/disclosure");
const drd_1 = require("../core-model-schemas/drd");
const hod_1 = require("../core-model-schemas/hod");
const tto_director_schema_1 = require("../core-model-schemas/tto-director-schema");
const z = __importStar(require("zod"));
exports.RelatedDisclosureIMSchema = z.lazy(() => disclosure_1.DisclosureSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
}).extend({
    contributors: z.array(contributor_1.ContributorIMSchema.omit({ disclosureId: true })),
    hODs: z.array(hod_1.HODIMSchema.omit({ disclosureId: true })),
    deans: z.array(dean_1.DeanIMSchema.omit({ disclosureId: true })),
    drd: drd_1.DRDCreateDTOSchema,
    ttoDirector: tto_director_schema_1.TtoDirectorCreateDTOSchema,
    score: disclosure_1.scoringSchema.nullish(),
}));
exports.DisclosureDTOSchema = z.lazy(() => disclosure_1.DisclosureSchema.omit({
    createdAt: true,
    updatedAt: true,
    id: true,
}).extend({
    contributors: z.array(contributor_1.ContributorSchema.omit({
        disclosureId: true,
        reason: true,
        id: true,
        signoffStatus: true,
    })),
    hODs: z.array(hod_1.HODSchema.omit({
        id: true,
        disclosureId: true,
        reason: true,
        signoffStatus: true,
    })),
    deans: z.array(dean_1.DeanSchema.omit({
        id: true,
        disclosureId: true,
        reason: true,
        signoffStatus: true,
    })),
}));
exports.DisclosureMinimalDetailsSchema = z.lazy(() => disclosure_1.DisclosureSchema.pick({
    submissionId: true,
    primaryEmail: true,
    primaryFirstName: true,
    name: true,
}));
